

export function joinPaths(paths: string[]): string {
    let path = '';

    for(const segment of paths) {
        if (path.endsWith('/')) {
            if (segment.startsWith('/')) {
                path += segment.substring(1);
            } else {
                path += segment;
            }
        } else {
            if (segment.startsWith('/')) {
                path += segment;
            } else {
                path += '/' + segment;
            }
        }
    }
    return path;
}